import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { PostErrorResponse, PostSigninRequest } from './types';
import { GetSigninResponse } from '../get';

export const postSignin = async (data: PostSigninRequest, lang = 'en', token: string | null | undefined): Promise<GetSigninResponse> => {
	const headers = {
		'Content-Type': 'application/json',
		...(token && { "X-XSRF-TOKEN": token }),
	};
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/signin?${queryParams.join('&')}`, {
		method: 'POST',
		credentials: 'include',
		headers: headers,
		body: JSON.stringify(data),
	})
		.then((res) => {
			if (res.ok) return res.json().then(response => response as GetSigninResponse);
			return res.json().then(errorResponse => {
				throw errorResponse as PostErrorResponse
			});
		})
		.then((successResponse) => successResponse)
		.catch((error: PostErrorResponse) => {
			throw error;
		});
};
